import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

const StyledButton = styled(Button)(({ theme }) => {
  return {
    margin: theme.spacing(1),
  };
});

const PrimaryButton = ({ children, handleClick, ...props }) => {
  return (
    <StyledButton
      variant="contained"
      color="primary"
      onClick={handleClick}
      {...props}
    >
      {children}
    </StyledButton>
  );
};

PrimaryButton.propTypes = {
  children: PropTypes.node.isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default PrimaryButton;
